<template>
    <!-- Outdated CARD -->

    <CardAbstract class="card-base" :dense="false">
        <div class="header">
            <div class="title-outer">
                <div class="title-small"></div>
                <div class="title-large">
                    <slot name="card-title" />
                </div>
                <div class="title-small">
                    <v-btn v-if="refreshable" elevation="0" color="lightbase" @click="handleRefresh">
                        <v-icon icon="fa-solid fa-arrows-rotate"></v-icon>
                    </v-btn>
                </div>
            </div>
        </div>
        <div class="card-outer-content">
            <slot name="card-content" />
        </div>
    </CardAbstract>
</template>

<script>
import { CardAbstract } from '@generio-ai/library-legacy/components/cards'

    export default {
        name: 'Card',
        components: {
            CardAbstract
        },
        props: {
            loading: {
                type: Boolean,
                default: false
            },
            refreshable: {
                type: Boolean,
                default: false
            }
        },
        emits: ['refresh'],
        methods: {
            handleRefresh() {
                if (this.refreshable) this.$emit('refresh')
            }
        }
    }
</script>

<style>
    .title-outer .v-icon {
        font-size: 18px;
        padding-bottom: 4px;
    }
</style>

<style scoped>
.card-base {
    display: flex;
    flex-direction: column;
    padding-top: 0px !important;
}

.card-base .header {
    position: relative;
	width: 100%;
	padding: 0px;
    padding-top: 15px;
    padding-bottom: 15px;
	overflow: unset;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	gap: 20px;
    line-height: 1.0;
    text-align: center;
	font-weight: 500;
    color: rgb(var(--v-theme-primary));
    background-color: rgb(var(--v-theme-darkbase));
}

.card-base .header::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1px;
  background: linear-gradient(
    to right,
    transparent 0%,
		rgb(var(--v-theme-background)) 20%,
		rgb(var(--v-theme-background)) 80%,
		transparent 100%
  );
}

    .card-outer-content {
        display: block;
        padding: 0px !important;
        padding-top: 20px !important;
        padding-bottom: 20px !important;
    }

    .title-outer {
        width: 100%;
        min-height: 36px;
        display: flex;
        flex-direction: row;
        font-size: 1.4rem;
    }

    .title-small {
        min-width: 64px;
    }

    .title-large {
        flex-grow: 1;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .title-small .v-icon {
        padding-bottom: 0px;
    }

    .v-btn {
        background: rgb(var(--v-theme-darkground));
    }

    @media (max-width: 750px)
    {
        .card-outer-content {
            padding-top: 10px !important;
            padding-bottom: 10px !important;
        }

        .title-small .v-icon {
            font-size: 16px;
        }
    }
</style>